export default __webpack_public_path__ + "static/media/summary.1c7edb35.svg";